import React from 'react';


function FormattedNumberCustom(props) {
  const currPorps = props;
  const value = currPorps.value;
  const LOCAL_STORAGE_KEY = 'redux_state';
  const persistedState = localStorage.getItem(LOCAL_STORAGE_KEY);
  const store = persistedState ? JSON.parse(persistedState) : {};
  const user = store.user;
  const thousandSep = new Intl.NumberFormat('en-US').format(value);
  return (
    <span className="custom-formated-currency">
      {thousandSep }
    </span>
  );
}
export default FormattedNumberCustom;